import { env } from '../env';

export function isVirtualMerchant(merchantId: number | string | null | undefined): boolean {
  if (merchantId == null) return false;

  const virtualId = env.REACT_APP_VIRTUAL_MERCHANT_ID;
  if (!virtualId) return false;

  return String(merchantId) === String(virtualId);
}